import {
  specificTeamMemberToOptionDeleted,
  emailToOptionDeleted,
} from 'services/helpers';
import {
  checkDeleted,
  displayNameDescriptor,
  RECEIVING_INBOX,
} from 'pages/AutomationEngine/helpers';
import { AUTOMATION_STEPS } from 'pages/AutomationEngine/steps';

const forApi = (orgDetails) => {
  const { receivingInbox, selectedIntegratedInboxes, ...others } = orgDetails;

  const stepGoal = {
    ...others,
    triggers: [
      {
        type: AUTOMATION_STEPS.email_received.type,
        triggerEmailReceivedFromContact: {
          receivingInbox,

          ...(selectedIntegratedInboxes && {
            selectedIntegratedInboxes: selectedIntegratedInboxes.map(
              (inbox) => inbox.value
            ),
          }),
        },
      },
    ],
  };

  delete orgDetails.inboxCriteria;

  delete orgDetails.specificTeamMember;

  delete orgDetails.type;
  delete orgDetails.field;
  return {
    stepGoal,
    details: orgDetails,
  };
};

const defaultTriggerEmailReceivedFromContact = {
  specificTeamRole: undefined,
  receivingInbox: undefined,
  specificTeamMember: undefined,
  selectedIntegratedInboxes: undefined,
};

const forFlow = (firstTrigger, addErrorMessage, messageDictionary) => {
  const { receivingInbox, specificTeamMember, selectedIntegratedInboxes } =
    firstTrigger.triggerEmailReceivedFromContact ||
    defaultTriggerEmailReceivedFromContact;

  if (!firstTrigger.triggerEmailReceivedFromContact) {
    // missingtrigger, after import
    addErrorMessage(messageDictionary.automationFailedToLoad);
  }

  const flow = {
    type: AUTOMATION_STEPS.email_received_goal.type,
    receivingInbox,
  };

  if (selectedIntegratedInboxes) {
    flow.selectedIntegratedInboxes = selectedIntegratedInboxes.map((inbox) =>
      emailToOptionDeleted(inbox)
    );

    if (
      flow.selectedIntegratedInboxes.length === 0 &&
      receivingInbox === RECEIVING_INBOX.selectedIntegratedInboxes
    ) {
      addErrorMessage(
        messageDictionary.thereWasanErrorLoadingTheAssociatedInbox
      );
    }
  }

  if (specificTeamMember) {
    checkDeleted(
      messageDictionary,
      addErrorMessage,
      specificTeamMember,
      displayNameDescriptor
    );

    flow.specificTeamMember =
      specificTeamMemberToOptionDeleted(specificTeamMember);
  }

  return flow;
};

export const emailReceivedGoalDTO = {
  forApi,
  forFlow,
};
